import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent } from './ui/card';
import { Star, Quote } from 'lucide-react';

export default function Reviews() {
  const reviews = [
    {
      name: "Michael Rodriguez",
      location: "Orlando, FL",
      rating: 5,
      text: "Elite Roofing did an outstanding job on our roof replacement. Jeremy and his team were professional, communicative, and completed the work ahead of schedule. The quality is exceptional!"
    },
    {
      name: "Sarah Johnson",
      location: "Winter Garden, FL",
      rating: 5,
      text: "After storm damage, Elite Roofing helped us navigate the insurance claim process with detailed documentation. They made a stressful situation much easier. Highly recommend!"
    },
    {
      name: "David Chen",
      location: "Lake Nona, FL",
      rating: 5,
      text: "We needed emergency tarp service and Elite Roofing responded within hours. Their quick action prevented further damage to our home. Professional and reliable service all around."
    },
    {
      name: "Jennifer Martinez",
      location: "Kissimmee, FL",
      rating: 5,
      text: "Elite Roofing handled our commercial property's roof inspection and repairs. Their attention to detail and clear communication throughout the project was impressive. Great work!"
    }
  ];

  return (
    <section className="bg-slate-50 py-12 sm:py-16 md:py-24" id="reviews">
      <div className="mx-auto max-w-screen-xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12 sm:mb-16"
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-3 sm:mb-4">
            Reviews From Our Roofing Customers
          </h2>
          <p className="text-lg sm:text-xl text-slate-600">
            We Always Put Our Customers First!
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-6 sm:gap-8">
          {reviews.map((review, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Card className="h-full bg-white hover:shadow-xl transition-shadow duration-300">
                <CardContent className="p-6 sm:p-8">
                  <div className="flex items-center gap-1 mb-4">
                    {Array.from({ length: review.rating }).map((_, i) => (
                      <Star key={i} className="h-4 w-4 sm:h-5 sm:w-5 fill-yellow-400 text-yellow-400" />
                    ))}
                  </div>
                  
                  <div className="relative">
                    <Quote className="absolute -top-2 -left-2 h-6 w-6 sm:h-8 sm:w-8 text-slate-200" />
                    <p className="text-sm sm:text-base text-slate-700 leading-relaxed mb-6 relative z-10 italic">
                      "{review.text}"
                    </p>
                  </div>
                  
                  <div className="border-t pt-4">
                    <p className="font-bold text-slate-900 text-sm sm:text-base">{review.name}</p>
                    <p className="text-xs sm:text-sm text-slate-600">{review.location}</p>
                  </div>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}